
import { Vue, Component, Prop } from "vue-property-decorator";

import GET_CONTRACTOR_DETAILS from "@/apollo/contractors/GetContractorDetails.gql";

import InformationCard from "@/components/inforationCards/InformationCardNew.vue";
import MailTo from "@/components/common/MailTo.vue";
import PhoneTo from "@/components/common/PhoneTo.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import UILink from "@/components/common/UILink.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import CompanyContractorDetailedInformation from "@/components/contractors/ContractorDetailedInformationNew.vue";
import { getContractorRating } from "@/helpers/contractors/getContractorRating";

import {
  User,
  Contractor,
  User_Profile,
  Resource_Information_Card,
  Tag,
} from "@/generated/graphql";
import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";
import GET_RESOURCE_INFO from "@/apollo/contractors/GetResourceInfo.gql";

interface ContractorDetails {
  contractor: Contractor;
  activeProjectsCount: number;
  completedProjectsCount: number;
}

@Component({
  components: {
    CompanyContractorDetailedInformation,
    InformationCard,
    MailTo,
    LoadingOverlay,
    UILink,
    PhoneTo,
    CardBodyItem,
  },
  apollo: {
    contractorDetails: {
      query: GET_CONTRACTOR_DETAILS,
      variables() {
        return this.queryArgs;
      },
      update(data) {
        const activeProjectsCount = data.active.aggregate.count;
        const completedProjectsCount = data.completed.aggregate.count;
        if (typeof localStorage !== "undefined") {
          localStorage.removeItem("activeProjectsCount");
          localStorage.removeItem("completedProjectsCount");
          localStorage.setItem("activeProjectsCount", activeProjectsCount);
          localStorage.setItem(
            "completedProjectsCount",
            completedProjectsCount
          );
        }
        return {
          contractor: data.contractor_by_pk,
          activeProjectsCount: data.active.aggregate.count,
          completedProjectsCount: data.completed.aggregate.count,
        };
      },
    },
    resourceInfo: {
      query: GET_RESOURCE_INFO,
      variables() {
        return this.contractorId_;
      },
      update(setter) {
        return setter.resource_information_card;
      },
    },
  },
})
export default class About extends Vue {
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;

  contractorDetails?: ContractorDetails;
  processing: boolean = false;
  resourceInfo?: Resource_Information_Card;
  resourceTag?: Tag;
  ttest: [] = [];

  get queryArgs(): Object {
    return {
      id: this.contractorId,
      activeWhere: {
        project_activities: {
          contractor: {
            user_id: {
              _eq: this.contractorUserId,
            },
          },
        },
      },
      completedWhere: {
        project_activities: {
          _and: [
            {
              completed: { _eq: true },
            },
            {
              contractor: {
                user_id: { _eq: this.contractorUserId },
              },
            },
          ],
        },
      },
    };
  }

  get profile(): User_Profile {
    return this.user.profile!;
  }

  get resourceCardInfo(): Resource_Information_Card {
    return this.resourceInfo!;
  }
  get contractorId_(): Object {
    return {
      contractor_id: this.contractorId,
    };
  }

  get user(): User {
    return this.contractorDetails!.contractor!.user;
  }
  get source(): string {
    const source = this.contractorDetails?.contractor?.source;
    return source ? `+${source}` : "";
  }
  get rating(): number {
    const ratingAggregate =
      this.contractorDetails?.contractor.contractor_ratings_aggregate;
    if (!ratingAggregate) {
      return 0;
    }
    return getContractorRating(ratingAggregate);
  }

  // get phone(): string {
  //   const phone = this.user.private_data?.phone;
  //   return phone
  //     ? `+${phone}`
  //     : "";
  // }

  get userPhone(): String {
    if (!this.user.private_data?.phone) {
      return "";
    }
    return this.user.private_data?.phone;
  }
  get contractorProjectsLink(): RouteParams<{ id: string }> {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_PROJECTS,
      params: { id: this.contractorId },
    };
  }

  showModal(): void {
    this.$emit("open");
  }

  async refreshPage(): Promise<void> {
    this.processing = true;
    this.$apollo.queries.resourceInfo?.refetch();
    this.processing = false;
  }

  async refreshContractor(): Promise<void> {
    this.processing = true;
    await this.$apollo.queries.contractorDetails?.refetch();
    this.processing = false;
  }

  get userEmail(): String {
    if (!this.user.private_data.email) {
      return "";
    }
    return this.user.private_data.email;
  }
}
